import {EuiFieldNumber} from "@elastic/eui";

export interface IFieldPercentage {
    value: number,
    onChange: (value: number) => void,
    min?: number,
    max?: number,
    step?: number
}

export const FieldPercentage: React.FC<IFieldPercentage> = props => {

    return (
        <EuiFieldNumber append={'%'} value={(props.value * 100).toFixed(0) ?? 0} min={(props.min ?? 0) * 100} max={(props.max ?? .99) * 100} onChange={e => props.onChange(Number((Number(e.target.value) / 100).toFixed(4)))} step={props.step ?? 1} />
    )
}